import { AiSettingsResponse, AiSettingsService } from '../api';

interface PromptProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: AiSettingsResponse[]; total: number }>;
  create: (
    resource: string,
    params: any
  ) => Promise<{ data: AiSettingsResponse }>;
}

export const promptDataProvider: PromptProviderResource = {
  getList: async (resource, params) => {
    const { items } = await AiSettingsService.getAiSettingsHistory();
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  create: async (resource, params) => {
    const prompt = await AiSettingsService.addAiSettings(params.data);
    return { data: prompt };
  },
};
